import { HttpClient } from 'domain/ports';
import { MessageSchedulerGateway, ScheduledMessage } from 'domain/gateways';
import { alyviaCoreServiceApi } from 'utils/constants';

export class MessageSchedulerHttpGateway implements MessageSchedulerGateway {
  constructor(private readonly httpClient: HttpClient) {}
  async getAll(
    deviceId: string,
    userId: string,
    conversationId: string
  ): Promise<ScheduledMessage[]> {
    const responseData = await this.httpClient.get(
      `${alyviaCoreServiceApi}/messages/scheduled/${conversationId}?deviceId=${deviceId}&userId=${userId}&status=PENDING`
    );
    return responseData;
  }

  async schedule(messageData: ScheduledMessage): Promise<any> {
    const responseData = await this.httpClient.post(
      `${alyviaCoreServiceApi}/messages/schedule`,
      messageData
    );
    return responseData;
  }

  async update(
    scheduledMessageId: string,
    newSendAt: string | Date,
    message: string
  ): Promise<any> {
    const responseData = await this.httpClient.put(
      `${alyviaCoreServiceApi}/messages/scheduled/${scheduledMessageId}`,
      { sendAt: newSendAt, message }
    );
    return responseData;
  }

  async delete(scheduledMessageId: string): Promise<any> {
    const responseData = await this.httpClient.delete(
      `${alyviaCoreServiceApi}/messages/scheduled/${scheduledMessageId}`
    );
    return responseData;
  }
}

